const TemplateSelector = ({ setTemplate, setEmailBody }) => {
    const handleTemplateChange = (event) => {
      const selectedTemplate = event.target.value;
      setTemplate(selectedTemplate);
      
      if (selectedTemplate === 'Open_Enrollment') {
        setEmailBody('<h1>¡Open Enrollment!</h1><p>Open Enrollment starts today.</p>');
      } else if (selectedTemplate === 'Reminder') {
        setEmailBody('<h1>Reminder</h1><p>Do not forget your scheduled appointment with us.</p>');
      } else {
        setEmailBody('');
      }
    };
  
    return (
      <select className="template-selector" onChange={handleTemplateChange}>
        <option value="">Select Template</option>
        <option value="Open_Enrollment">Open Enrollment</option>
        <option value="Reminder">Reminder</option>
      </select>
    );
  };
  
  export default TemplateSelector;
  